import React from "react";
import { EventType } from "@gp/models";

import classnames from "classnames";
import { BetOffer } from "@models";
import MultiOffersComponent from "@components-shared/MultiOffersComponent";

export default function BetOfferItemTip(props: { offer: BetOffer }) {
	let str = "";
	if (props.offer.multiOffers && props.offer.multiOffers.length) {
		str = `${props.offer.formattedBettingType}`;
	} else if (props.offer.sportData.eventType === EventType.NORMAL) {
		str = `${props.offer.formattedBettingType} (${props.offer.formattedBettingTypeTip})`;
	} else {
		str = `${props.offer.formattedBettingTypeTip}`;
	}

	return (
		<td
			className={
				"table--bets__td table--bets__td--bet-type u-color--offer--" +
				props.offer.formattedBettingOfferStatus
			}
		>
			<span
				className={classnames({
					"u-type--wgt--medium": props.offer.multiOffers,
				})}
			>
				{str}
			</span>
			{props.offer.multiOffers && (
				<MultiOffersComponent multiOffers={props.offer.multiOffers} />
			)}
		</td>
	);
}
